import { Theme, alpha } from '@mui/material/styles';

export const formInputStyles = (theme: Theme) => ({
  '& .MuiInputBase-input': {
    transition: 'background-color 0s 86400s, color 0s 86400s',
    '&:-webkit-autofill': {
      WebkitBoxShadow: '0 0 0 100px #f5f5f5 inset',
      WebkitTextFillColor: theme.palette.text.primary,
      caretColor: theme.palette.text.primary,
      borderRadius: 'inherit',
    },
    '&:-webkit-autofill:hover': {
      WebkitBoxShadow: '0 0 0 100px #f0f0f0 inset',
    },
    '&:-webkit-autofill:focus': {
      WebkitBoxShadow: '0 0 0 100px #e8f0fe inset',
    },
    '&:-webkit-autofill:active': {
      WebkitBoxShadow: '0 0 0 100px #e8f0fe inset',
    },
    '&[type="number"]': {
      MozAppearance: 'textfield',
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
    },
  },
  '& .MuiInputBase-root': {
    backgroundColor: theme.palette.background.paper,
    transition: theme.transitions.create(
      ['background-color', 'box-shadow', 'border-color'],
      { duration: theme.transitions.duration.short }
    ),
    '&:hover': {
      backgroundColor: alpha(theme.palette.background.paper, 0.9),
    },
    '&.Mui-focused': {
      backgroundColor: theme.palette.background.paper,
    },
    '&.Mui-disabled': {
      backgroundColor: alpha(theme.palette.background.paper, 0.7),
    },
    '&.Mui-error': {
      backgroundColor: alpha(theme.palette.error.light, 0.1),
    },
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
    '&:hover fieldset': {
      borderColor: alpha(theme.palette.primary.main, 0.5),
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
      borderWidth: 2,
    },
    '&.Mui-error fieldset': {
      borderColor: theme.palette.error.main,
    },
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
    '&.Mui-error': {
      color: theme.palette.error.main,
    },
  },
  '& .MuiInputLabel-root': {
    '&.Mui-focused': {
      color: theme.palette.primary.main,
    },
    '&.Mui-error': {
      color: theme.palette.error.main,
    },
  },
  '& .MuiSelect-select': {
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  '& .MuiAutocomplete-input': {
    padding: '7.5px 4px 7.5px 5px !important',
  },
});

export const formContainerStyles = (theme: Theme) => ({
  p: { xs: 3, sm: 6 },
  borderRadius: 2,
  backgroundColor: alpha(theme.palette.background.paper, 0.95),
  backdropFilter: 'blur(10px)',
  boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.1)}`,
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
    opacity: 0.8,
  },
});

export const formButtonStyles = (theme: Theme) => ({
  height: 48,
  px: 4,
  borderRadius: 2,
  textTransform: 'none',
  fontSize: '1rem',
  fontWeight: 600,
  boxShadow: theme.shadows[2],
  '&:hover': {
    boxShadow: theme.shadows[4],
  },
  '&.Mui-disabled': {
    backgroundColor: alpha(theme.palette.primary.main, 0.4),
    color: theme.palette.primary.contrastText,
  },
});

export const numberInputProps = {
  onKeyDown: (e: React.KeyboardEvent) => {
    if (['e', 'E', '+', '-'].includes(e.key)) {
      e.preventDefault();
    }
  },
  inputMode: 'decimal' as const,
  pattern: '[0-9]*\\.?[0-9]*',
}; 